export const formDataNoticeBoardCreate = (defaultData?: NoticeBoardCreated): FormParams => {
  return {
    items: {
      upperFields: [
        {
          element: 'input',
          type: 'text',
          id: 'title',
          placeHolder: 'Título do mural',
          label: 'Título do mural',
          defaultValue: defaultData ? defaultData.noticeBoardItem.title : null,
        },
        {
          element: 'input',
          type: 'file',
          id: 'image',
          label: 'Adicionar imagem',
        },
      ],
      bottomFields: [
        {
          element: 'input',
          type: 'file',
          id: 'attachment',
          label: 'Anexar arquivo',
        },
      ],
    },
    style: 'gray',
  };
};
